import type { ReactNode } from "react";
import { RainbowWrapper as KitRainbowWrapper } from "lola-framework-ui-test";
import { useStore } from "../store/globalState";

export interface RainbowWrapperProps {
  /** Kept for call-site compat; kit does not use it. */
  value?: string | number;
  error?: string;
  children: ReactNode;
  isActive?: boolean;
}

/** Pull color stops from primaryMesh / backgroundBtn gradient. */
const MESH_COLOR_RE =
  /#(?:[0-9a-fA-F]{3,8})\b|rgba?\([^)]+\)|hsla?\([^)]+\)/g;

function colorsFromPrimaryMesh(mesh?: string): string[] {
  if (!mesh) return [];
  return mesh.match(MESH_COLOR_RE) ?? [];
}

export const RainbowWrapper = ({
  error,
  children,
  isActive = false,
}: RainbowWrapperProps) => {
  const { theme } = useStore();
  // whiteView.backgroundBtn is the resolved primaryMesh gradient.
  const backgroundBtn = theme?.whiteView?.backgroundBtn;
  const customRainbowColors = colorsFromPrimaryMesh(backgroundBtn);

  return (
    <KitRainbowWrapper
      error={error}
      isActive={isActive}
      backgroundBtn={backgroundBtn}
      customRainbowColors={customRainbowColors}
      isStatic
    >
      {children}
    </KitRainbowWrapper>
  );
};
